import { LoadingOutlined } from '@ant-design/icons';
import { Edit } from '@material-ui/icons';
import { Button, DatePicker, Form, Input, message, Select, Spin, Table } from 'antd';
import moment from 'moment';
import React, { useState } from 'react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import roleManager from '../../../Components/roles';
import { editOOSInspectionHistory, getOOSHistory_OOSCodes } from '../../../Services/LocomotiveServices';

const OutOfServiceDetails = ({ data, setRefresh, setEditingKey, editingKey }) => {
    const [form] = Form.useForm();
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [oosCodes, setOosCodes] = useState([])
    const [oosCode, setOosCode] = useState(null)
    let { oosTable } = useSelector((state) => state?.utils?.pageLoader);

    const isEditing = (record) => record.id === editingKey;

    const onStartChange = (date) => {
        setStartDate(date);
        if (endDate && date && date.isAfter(endDate)) {
            setEndDate(null);
        }
    };

    const onEndDateChange = (date) => {
        setEndDate(date);
    };

    const disabledEndDate = (current) => {
        return current && (current.isAfter(moment(), 'day') || (startDate && current.isSameOrBefore(startDate, 'day')));
    };

    const disabledStartDate = (current) => {
        if (!endDate) return current && current.isAfter(moment().endOf("day"));
        return current && endDate && current.isSameOrAfter(endDate, 'day');
    };

    const edit = (record) => {
        form.setFieldsValue({
            startDate: record?.StartDate ? moment(record?.StartDate)?.utc() : undefined,
            endDate: record?.EndDate ? moment(record?.EndDate)?.utc() : undefined,
            code: record?.OosCode,
        });
        record?.StartDate && setStartDate(moment(record?.StartDate)?.utc())
        record?.EndDate && setEndDate(moment(record?.EndDate)?.utc())
        record.OosCode && setOosCode(record?.OosCode)
        setEditingKey(record.id);
    };

    const cancel = () => {
        setStartDate(null);
        setEndDate(null);
        setOosCode(null)
        setEditingKey('');
    };

    const save = async (id) => {
        if (!form?.getFieldValue('code')) return message?.error('OOS code cannot be empty!');

        let data = {
            StartDate: form?.getFieldValue('startDate')
                ? form?.getFieldValue('startDate')?.format('MM-DD-YYYY')
                : null,
            EndDate: form?.getFieldValue('endDate')
                ? form?.getFieldValue('endDate')?.format('MM-DD-YYYY')
                : null,
            OosCode: form?.getFieldValue('code'),
        };

        let result = await editOOSInspectionHistory(id, data);
        if (result?.httpStatus === 200) {
            setRefresh((prev) => !prev);
            setEditingKey('');
            setStartDate(null);
            setOosCode(null)
            setEndDate(null);
        }
    };


    const EditableCell = ({
        editing,
        dataIndex,
        title,
        record,
        index,
        children,
        ...restProps
    }) => {
        const inputNode =
            dataIndex === 'startDate' ? (
                <DatePicker
                    allowClear={false}
                    onChange={onStartChange}
                    disabledDate={disabledStartDate}
                />
            ) : dataIndex === 'endDate' ? (
                <DatePicker
                    allowClear={false}
                    onChange={onEndDateChange}
                    disabledDate={disabledEndDate}
                    disabled={!record?.EndDate ? true : false}
                />
            ) : (
                <Select
                    showSearch
                    allowClear={false}
                    options={oosCodes?.map(x => { return { value: x?.IS_OS_Code, label: x?.IS_OS_Code } })}
                    filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                    onChange={value => setOosCode(value)}
                    value={oosCode}
                />
            );

        return (
            <td {...restProps}>
                {editing ? (
                    <Form.Item
                        name={dataIndex}
                        style={{
                            margin: 0,
                        }}
                        rules={[
                            {
                                required: true,
                                message: `Please Input ${title}!`,
                            },
                        ]}
                    >
                        {inputNode}
                    </Form.Item>
                ) : (
                    children
                )}
            </td>
        );
    };


    const columns = [
        {
            title: 'OOS Code',
            dataIndex: 'code',
            key: 'code',
            editable: roleManager("locomotive", "lookupEdit", "oos_code") ? true : false,
            render: (_, record) => <span>{record?.OosCode || 'N/A'}</span>,
        },
        {
            title: 'Location',
            dataIndex: 'loc',
            key: 'loc',
            render: (_, record) => <span>{record?.TGSLocation?.Abv || 'N/A'}</span>,
        },
        {
            title: 'Start Date',
            dataIndex: 'startDate',
            key: 'startDate',
            editable: true,
            render: (_, record) => (
                <span>
                    {record?.StartDate ? moment(record?.StartDate)?.utc()?.format('MM-DD-YYYY') : 'N/A'}
                </span>
            ),
        },
        {
            title: 'End Date',
            dataIndex: 'endDate',
            key: 'endDate',
            editable: true,
            render: (_, record) => (
                <span>
                    {record?.EndDate ? moment(record?.EndDate)?.utc()?.format('MM-DD-YYYY') : 'N/A'}
                </span>
            ),
        },
        {
            title: 'Days',
            dataIndex: 'days',
            key: 'days',
            render: (_, record) => <span>{record?.DaysOos || '0'}</span>,
        },
        {
            align: 'center',
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <div className="outOfService_table_edit">
                        <button
                            style={{
                                background: '#2863ad',
                                color: 'white',
                                borderRadius: '3px',
                                border: 'none',
                                cursor: 'pointer',
                            }}
                            onClick={() => save(record.id)}
                        >
                            Save
                        </button>
                        <span
                            onClick={cancel}
                            style={{
                                background: 'white',
                                color: '#2863ad',
                                borderRadius: '3px',
                                boxShadow: 'none',
                                fontSize: '13px',
                                padding: '2px 4px',
                                border: '1px solid lightgray',
                                cursor: 'pointer',
                            }}
                        >
                            Cancel
                        </span>
                    </div>
                ) : (
                    <Edit className="editTableIcon" onClick={() => edit(record)} />
                );
            },
        },
    ];

    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
                render: col?.render,
            }),
        };
    });

    useEffect(() => {
        (async () => {
            let response = await getOOSHistory_OOSCodes()
            if (response?.httpStatus === 200) {
                setOosCodes(response?.data)
            }
        })();
    }, [])



    return (
        <Form form={form} component={false}>
            <Spin
                spinning={oosTable || false}
                indicator={
                    <LoadingOutlined
                        style={{
                            fontSize: 24,
                        }}
                        spin
                    />
                }
            >
                <Table
                    dataSource={data}
                    columns={mergedColumns}
                    components={{
                        body: {
                            cell: EditableCell,
                        },
                    }}
                    pagination={data?.length > 10 ? true : false}
                />
            </Spin>
        </Form>
    );
};
export default OutOfServiceDetails;
